require( 'fslightbox' );

( function ( $ ) {

	// Add click listener for fsLightbox.
	document.getElementById( 'farside-parent' ).addEventListener( 'click', e => {
		fsLightbox.open();
	} );

	// Fetch our custom endpoint that returns the anchor element with thumbnail.
	wp.apiFetch( {
		path: 'farside/v1/random',
	} ).then( data => {
		document.getElementById( 'farside-parent' ).innerHTML = data;
		refreshFsLightbox();
	} );

} )( jQuery );
